(function () {
    'use strict';
    angular.module('app').controller('refreshextracteddata', refreshextracteddata);
    refreshextracteddata.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'zcs', 'extractionservice'];
    function refreshextracteddata($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, zcs, extractionservice) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        // PL-OBS? scope.assignDialogShown = false;
        scope.ACN_ASSIGN = 121;
        scope.ACN_UNASSIGN = 122;
        scope.xyz = { bReadyForOK: false, filenameLabel: "--", activityLabel: "--", bCancelButtonClicked: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // scope
        scope.slx = records;

        //List of libraries needing fts extraction
        var ftsExtractLibs = { "ADEPT_NULL_LIBID": false };


        // dialog config
        scope.heading = loginService.resourceStrings["TITLE_REFRESH_EXTRACTED_DATA"]; // "Refresh Extracted Data"; // loginService.resourceStrings["ASSIGN"]; // "Assign";
        scope.OK = loginService.resourceStrings["OK"]; // "OK";
        scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var item = list[workNumber];

            scope.xyz.filenameLabel = item.filename;

            scope.xyz.activityLabel = loginService.resourceStrings["REFRESH_EXTRACTED_DATA_ACTIVITY_GETVLPATH"]; // "Get VL Path";
            zcs.GetLocalVirtualLibraryPath(true).then(function (data) {
                scope.xyz.activityLabel = loginService.resourceStrings["REFRESH_EXTRACTED_DATA_ACTIVITY_GETACCESSPATH"]; // "Get Access Path";
                var localVirtualLibraryPath = data;
                selectionCommandService.GetLocalAccessPath(item.tableNumber, item.fileId, item.majRev, item.minRev, localVirtualLibraryPath).then(function (response) {
                    scope.xyz.activityLabel = loginService.resourceStrings["REFRESH_EXTRACTED_DATA_ACTIVITY_PROCESSFILEOP"]; // "Process File Operation";
                    var fileOperationPacket = response.data;

                    // No file?
                    if (fileOperationPacket == null || fileOperationPacket.fileOperations == null || fileOperationPacket.fileOperations.length < 1)
                    {
                        deferred.resolve();
                        return deferred.promise;
                    }

                    zcs.ProcessFileOperationPacket(fileOperationPacket, true).then(function (data) {
                        scope.xyz.activityLabel = loginService.resourceStrings["REFRESH_EXTRACTED_DATA_ACTIVITY_EXTRACT"]; // "Extract";
                        var filePNE = fileOperationPacket.fileOperations[0].destinationFile;
                        // If already in a WorkArea, then there was no file transfer, so the sourceFile is the location.
                        if (filePNE == null)
                            filePNE = fileOperationPacket.fileOperations[0].sourceFile;

                        checkFTSExtract(item.detailedInfo.libId).then(function (extractFTS) {
                            extractionservice.extractWAItem(filePNE, extractFTS).then(function (response) {
                                scope.xyz.activityLabel = loginService.resourceStrings["REFRESH_EXTRACTED_DATA_ACTIVITY_UPDATEREC"]; // "Update Record";
                                var extractionDataModel = response;
                                if (extractionDataModel != null) {
                                    extractionDataModel.AdeptTableNumber = item.tableNumber;
                                    extractionDataModel.AdeptFileId = item.fileId;
                                    extractionDataModel.AdeptMajorRevision = item.majRev;
                                    extractionDataModel.AdeptMinorRevision = item.minRev;
                                    //2018 SP1 Refactor: 20180828 - GT
                                    //changed qualifying service from selectionCommandService to extractionservice
                                    extractionservice.updateExtractedData(extractionDataModel).then(function () {
                                        // When it is done, we are done.
                                        deferred.resolve();
                                    }, function (response) {
                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                    });
                                }
                                else {
                                    deferred.resolve();
                                }
                            }, function () {
                                deferred.resolve(); // Let that service show its exception, but we will keep going.
                            });
                        }, function () {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });                   
                    }, function () {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                    });
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }, function (response) {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            // Return the promise for doing the work.
            return deferred.promise;
        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();

            // Do one item.
            doOne(list, workNumber).then(function () {

                if (scope.xyz.bCancelButtonClicked) {
                    deferred.resolve();
                    return deferred.promise;
                }

                // When that is done, ...
                // Incement the item number that we are going to work on.
                workNumber++;
                // If we are still in the list, ...
                if (workNumber < list.length) {
                    // Recurse on the next item.
                    doLoop(list, workNumber).then(function () {
                        // When that is done. Resolve the promise from before.
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }
                else { // We are done with the list.
                    // Resolve this item.
                    deferred.resolve();
                    // Return the promise.
                    return deferred.promise;
                }
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for the current item.
            return deferred.promise;
        }

        scope.walkLoop = function () {
            // Start the loop.
            var workNumber = 0;
            doLoop(scope.slx.list, workNumber).then(function () {
                // Close the dialog when finished.
                $mdDialog.hide();
                // Done.
                scope.xyz.processing = false;

                gridDataService.updateGridRecords(scope.slx.list); // 2018-02-05

                //2018 SP1 Refactor: 20180829 - GT
                //release plugin applications after refresh of extracted data
                extractionservice.releasePluginApplications();

            }, function () {
                scope.xyz.processing = false;
            });
        }

        scope.onRefreshExtractedDataDialogOK = function () {
            scope.xyz.processing = true;
            if (zcs.bAcsInitPlugInsDone) {
                scope.walkLoop();
            }
            else {
                //2018 SP1 Refactor: 20180828 - GT
                //changed qualifying service from selectionCommandService to extractionservice
                //Bill 0-28-2018 was misspelled as  "GetPlugInDefinitions"
                extractionservice.getPluginDefinitions().then(function (data) {
                    zcs.AcsInitPlugIns(data).then(function () {
                        scope.walkLoop();
                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            }
        };

        scope.onRefreshExtractedDataDialogOK();

        scope.onRefreshExtractedDataDialogCancel = function () {
            scope.xyz.bCancelButtonClicked = true;

            $rootScope.msgBoxShow(loginService.resourceStrings["CANCELLED"], "");
            // Close dialog.
            $mdDialog.hide();
        };

        function checkFTSExtract(libId) {

            var deferred = $q.defer();

            if (libId in ftsExtractLibs) {
                deferred.resolve(ftsExtractLibs[libId]);
            }
            else {
                //call the server
                extractionservice.checkFTSExtract([libId]).then(function (response) {
                    if (libId in response.data)
                        response.data[libId] = response.data[libId];

                    deferred.resolve(response.data[libId]);

                });
            }

            return deferred.promise;
        }

    }
})();
